// Tailwind CSS classes handler
export const handleClassNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};
